import React from "react";

const NoCoupon = () => {
  return (
    <>
      <div className="bg-white px-3 px-md-4 rounded-2">
        <div className="row">
          <div className="col-12 mb-2 text-center">
            <img
              src="/assets/images/icon-order-history-empty.png"
              className="icon-order-history-empty my-4"
              alt=""
            />
            <p className="m-0">ยังไม่มีรายการคูปองส่วนลด</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoCoupon;
